<template>
  <div class="district-select-container">
    <v-select
      :items="stateList"
      v-model="selectedState"
      data-cy="district-search"
    >
      <template slot="label"
        ><span style="font-size: 12px; font-weight: normal"
          >State selection</span
        ></template
      >
      <!-- <template slot="append"><span style="font-size: 12px; font-weight: bold; color:red;">(in litigation)</span></template> -->
    </v-select>
  </div>
</template>
<script>
import { EventBus } from "../../js/DataManagement/EventBus";
//:suffix="isFinal || side==='A'? '' : '(in litigation)'"
export default {
  name: "StateSearch",
  props: ["side", "isFinal"],
  components: {},
  data: function () {
    return {
      stateList: [],
      selectedState: "",
    };
  },
  mounted: function () {
    let self = this;

    this.$nextTick(() => {
      self.stateList = this.$stateData.states
        .sort((a, b) => a.statename.localeCompare(b.statename))
        .map(({ statename, statefips }) => ({ text: statename, value: statefips }));
    });
   
    EventBus.$on("clearAddress", () => {
     // self.selectedState = "";
    });
  },
  methods: {},
  watch: {
    "$store.state.selectedState": function (val) {
      if (+val === +this.selectedState) return;
      this.selectedState = val;
    },
    selectedState: function (val) {
      if (val === this.$store.getters.getSelectedState || val.length === 0)
        return;

      if (!val.length || typeof val.length === "undefined") return;
      if (val.length > 0) {
        EventBus.$emit("clearAddress");
        EventBus.$emit("clearSidePanels");
        EventBus.$emit("clear-selected-districts");
        this.$forceUpdate();
        this.$store.commit("setSelectedState", val);
        EventBus.$emit("zoomToState");
      }
    },
  },
  computed: {},
};
</script>


<style scoped>
.form-group {
  white-space: nowrap;
}

/* .v-toolbar .v-input {
  margin-top: 5%;
  display: inline-block;
  width: 49%;
  caret-color: black;
  float: right;
} */
</style>
<style>
.district-select-container,
.district-select-container .v-label {
  margin-top: 4px !important;
  font-weight: normal;
}
</style>
